import Card from "./Card";

function CardDisplay() {

  // card component is all controlled by data
  // employee card or view more/less card
  // all other fields can be empty
const card1 = {
    name: "Charles M. Tiberio",
    id: "CH123456",
    title: "Director, Financial Reporting",
    department: "Controller - Management",
    phone: "617-218-1234",
    email: "germain.harper@childrens.harvard.edu",
    // address: "100 Longwood Ave, Building",
    // pager: "12345",
    photo:
      "https://uploads.codesandbox.io/uploads/user/38ce02f1-7e6f-449d-8351-5096bfbfc8ed/VaRz-pexels-pixabay-220453.jpg"
  };

  // button function need to have both
  // button label and action to make it show
  const card2 = {
    photo:
      "https://uploads.codesandbox.io/uploads/user/38ce02f1-7e6f-449d-8351-5096bfbfc8ed/PAjj-placeholder-image-600x400.jpg",
    content:
      "Try to limit displayed content to one sentence to save space. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.",
    viewMore: "View more",
    viewLess: "View less",
    buttonLabel: "Link to somewhere"
    //buttonAction: ""
  };

  // can put tranlastion string for
  // view less/more here
  const card3 = {
    photo:
      "https://uploads.codesandbox.io/uploads/user/38ce02f1-7e6f-449d-8351-5096bfbfc8ed/PAjj-placeholder-image-600x400.jpg",
    content:
      "Try to limit displayed content to one sentence to save space. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.",
    viewMore: "Ver más",
    viewLess: "Ver menos",
    buttonLabel: "Link to somewhere",
    buttonAction: { justLog }
  };

  function justLog(e) {

  }

  return (
    <div>
      <Card data={card1} id="card1" />
      <br />
      <Card data={card2} id="card2" />
      <br />
      <Card data={card3} id="card3" />
      <br />
    </div>
  );
}

export default CardDisplay;
